











import { Component, Vue } from 'vue-property-decorator';
import AppFooter from '@/components/page/AppFooter.vue'; 
import Navbar from '@/components/page/Navbar.vue'
import HealthQuery from '@/graphql/queries/health.gql';
import request, { API_HOST } from '@/graphql/request';

@Component({
  components: {
    Navbar,
    AppFooter,
  },
})
export default class App extends Vue {
  public isApiOnline = true;

  public mounted() {
    document.title = 'Hatsui Azione';
    this.checkApiStatus();
    this.$store.dispatch('refreshUser');
  }

  public created() {
    const fa = document.createElement('script');
    fa.setAttribute(
      'src',
      'https://use.fontawesome.com/releases/v5.0.7/js/all.js'
    );
    document.head.appendChild(fa);
  }

  public createLoginText(): string {
    if (this.$store.getters['auth/authenticated']) {
      return 'Log out'
    } else {
      return 'Log In/Sign Up'
    }
  }

  private async checkApiStatus() {
    const status = request(HealthQuery)
      .then(response => {
        if (response.data.health.length > 0) {
          this.isApiOnline = true;
        }
      })
      .catch(() => {
        this.isApiOnline = false;
      });
  }
 
}
